import React, { useEffect, useState } from 'react';
import { Typography, Box, Select, MenuItem, FormControl, Dialog, useMediaQuery } from '@mui/material';
import { PaySystemBox } from '../../libs/theme';
import REST from '../../libs/API';
import PaySystemList from '../main/PaySystemList';
import OrderFormFields from '../main/OrderFormFields';
import PSIcon from '../../components/PSIcon';
import { getText } from '../../libs/utils';
import { useTheme } from "@mui/material/styles";


const RequisitesAddWallet = ({ systems = [], userToken, updateWallets }) => {
  const theme = useTheme();
  let isXS = useMediaQuery(theme.breakpoints.only('xs'));
  let isSM = useMediaQuery(theme.breakpoints.only('sm'));
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [activeSystem, setActiveSystem] = useState(systems[0]);
  const [activeCurrency, setActiveCurrency] = useState(systems[0].currencies[0]);
  const [formData, setFormData] = useState({});
  const [formFields, setFormFields] = useState({});

  useEffect(() => {
    getFormData();
  }, [activeCurrency]);

  const getFormData = () => {
    REST.getWalletFields(userToken, activeSystem.id, activeCurrency.id).then((data) => {
      const filteredData = data.filter(field => !field.hidden);
      setFormFields(filteredData);
    });
  }

  const handleSelectCurrency = (event) => {
    const currencyId = event.target.value;
    setActiveCurrency(activeSystem.currencies.find((item) => item.id === currencyId));
  }

  const handleSubmitForm = () => {
    setLoading(true);
    REST.sendWallet(userToken, activeSystem.id, activeCurrency.id, formData)
      .then(data => {
        if (!data.success) {
          window.showMessage(data.data[0].message, { variant: 'warning' });
        } else {
          window.showMessage(getText("accReqAddSuccess"));
          setFormData({});
          updateWallets();
        }
        setLoading(false);
      })
  }

  const selectSystemField = <Box className="form-field">
    <PaySystemBox>
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => setOpenDialog(true)}>
        <PSIcon
          name={activeSystem.className}
          height={24}
          width={24}
          margin="0 10px 0 0"
        />
        {activeSystem.label}
      </Box>
      <FormControl size="small">
        <Select
          value={activeCurrency.id}
          onChange={handleSelectCurrency}
          disabled={activeSystem.currencies.length <= 1 ? true : false}
          MenuProps={{
            PaperProps: {
              variant: "small",
            },
          }}
        >
          {activeSystem.currencies.map((item, key) => (
            <MenuItem
              key={key}
              value={item.id}
              sx={{ display: activeCurrency.id === item.id ? 'none' : 'inherit' }}
            >
              {item.network || item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </PaySystemBox>
  </Box>;

  return (
    <>
      <Typography variant="h4">{getText('accReqAddTitle')}</Typography>

        {formFields.length > 0 &&
          <OrderFormFields
            className="add-wallet"
            additionalField={selectSystemField}
            fields={formFields}
            handleSubmitOrder={handleSubmitForm}
            formData={formData}
            setFormData={setFormData}
            buttonLeftCol={false}
            loading={loading}
            button="Добавить реквизит"
          />}


      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="lg"
        classes={{
          paper: 'inner-scroll'
        }}
      >
        <PaySystemList
          title={getText('selectPs')}
          list={systems}
          onClose={() => setOpenDialog(false)}
          activeSystem={activeSystem}
          setSystem={setActiveSystem}
          setCurrency={setActiveCurrency}
          grid={isSM ? 4 : isXS ? 2 : 5}
        />
      </Dialog>
    </>
  )
}

export default RequisitesAddWallet